 const CONSTS = {
    HEADER_HEIGHT: '70px',
    light: {
        PRIMARY_COLOR: 'gray.200',
        PRIMARY_COLOR_BORDER: 'gray.100',
        SECONDARY_COLOR: 'blue',
    },
    dark: {
        PRIMARY_COLOR: 'gray.900',
        PRIMARY_COLOR_BORDER: 'gray.600',
        SECONDARY_COLOR: 'blue',
    }
}

export default CONSTS;